import {
  AutofillAttendanceShiftDocument,
  AutofillAttendanceShiftMutationVariables,
  TimeTrackingClockInPageDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useAutofillAttendanceShifts = () => {
  const [autofillAttendanceShifts, { loading }] = useMutation(AutofillAttendanceShiftDocument, {
    extractorFn: (data) => data.attendanceMutations.autofillAttendanceShift,
    refetchQueries: [TimeTrackingClockInPageDocument],
  })

  const autofillTimesheet = (variables: AutofillAttendanceShiftMutationVariables) => {
    return autofillAttendanceShifts({
      variables,
    })
  }

  return {
    loading,
    autofillTimesheet,
  }
}
